export default __webpack_public_path__ + "static/Branches-090702887834bb2e7572d56f8116caba.png";